module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('gs-header', {
    attrs: {
      "title": ("Chi tiết phiếu thu: <span class='shipment-code-display click-copy'>" + (_vm.receipt.id) + "</span>"),
      "breadcrumbs": [{
        title: 'Quản lý phiếu thu',
        route: {
          name: 'receipt'
        }
      }]
    }
  }, [_c('el-popover', {
    ref: "confirmPopup",
    attrs: {
      "placement": "top",
      "width": "200"
    },
    model: {
      value: (_vm.confirmPopup),
      callback: function($$v) {
        _vm.confirmPopup = $$v
      },
      expression: "confirmPopup"
    }
  }, [_c('p', [_vm._v("Bạn chắc chắn muốn xác nhận phiếu thu này?")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right",
      "margin": "0"
    }
  }, [_c('button', {
    staticClass: "ui red mini basic button",
    on: {
      "click": function($event) {
        _vm.confirmPopup = false
      }
    }
  }, [_vm._v("Không")]), _vm._v(" "), _c('button', {
    staticClass: "ui green mini basic button",
    attrs: {
      "disabled": !_vm.confirmPopup
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.confirmReceipt.apply(null, arguments)
      }
    }
  }, [_vm._v("Xác\n          nhận")])])]), _vm._v(" "), (_vm.receipt.client_id && _vm.receipt.confirmer_id) ? _c('a', {
    staticClass: "ui mini violet button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.returnHandler.apply(null, arguments)
      }
    }
  }, [_vm._v("Cần\n      truy thu")]) : _vm._e(), _vm._v(" "), (_vm.receipt.client_id && _vm.receipt.confirmer_id) ? _c('a', {
    staticClass: "ui mini violet button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.returnedHandler.apply(null, arguments)
      }
    }
  }, [_vm._v("Đã truy thu")]) : _vm._e(), _vm._v(" "), _c('a', {
    directives: [{
      name: "popover",
      rawName: "v-popover:confirmPopup",
      arg: "confirmPopup"
    }, {
      name: "show",
      rawName: "v-show",
      value: (!_vm.receipt.confirmer_id),
      expression: "!receipt.confirmer_id"
    }],
    staticClass: "ui mini green button"
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v("\n      Xác nhận")])], 1), _vm._v(" "), (_vm.receipt.id) ? _c('div', {
    staticClass: "padding-sm-all margin-top padding-lg-bottom"
  }, [_c('el-row', {
    staticClass: "remove-margin",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    staticClass: "border-right",
    attrs: {
      "span": 12
    }
  }, [_c('h3', {
    staticClass: "text-center"
  }, [_vm._v("Người tạo")]), _vm._v(" "), _c('p', [_vm._v("Họ tên: " + _vm._s(_vm.receipt.creator.data.name))]), _vm._v(" "), _c('p', [_vm._v("Tên đăng nhập: " + _vm._s(_vm.receipt.creator.data.email))]), _vm._v(" "), _c('p', [_vm._v("Ngày tạo: " + _vm._s(_vm.receipt.created_at))])]), _vm._v(" "), _c('el-col', {
    staticClass: "border-right",
    attrs: {
      "span": 12
    }
  }, [_c('h3', {
    staticClass: "text-center"
  }, [_vm._v("Xác nhận")]), _vm._v(" "), _c('p', [_vm._v("Họ tên: " + _vm._s(_vm.receipt.confirmer.data.name))]), _vm._v(" "), _c('p', [_vm._v("Tên đăng nhập: " + _vm._s(_vm.receipt.confirmer.data.email))]), _vm._v(" "), _c('p', [_vm._v("Ngày tạo: " + _vm._s(_vm.receipt.confirmed_at))])]), _vm._v(" "), (_vm.receipt.client_id) ? _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    staticClass: "padding-lg-left padding-lg-all",
    attrs: {
      "span": 24
    }
  }, [_vm._v("\n          Khách hàng: " + _vm._s(_vm.receipt.client.data.name) + " | " + _vm._s(_vm.receipt.client.data.email) + "\n        ")])], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
    staticClass: "padding-lg-all bg-grey margin-top text-white",
    attrs: {
      "span": 24
    }
  }, [_vm._v("\n        Lý do: " + _vm._s(_vm.receipt.description) + "\n      ")])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "remove-margin margin-top"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('h3', {
    staticClass: "text-center"
  }, [_vm._v("Danh sách vận đơn")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.receipt.shipments.data,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "40"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Mã đơn",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_c('el-tooltip', {
          staticClass: "display-inline",
          attrs: {
            "placement": "top",
            "content": "Mã đơn"
          }
        }, [_c('span', {
          staticClass: "shipment-code-display click-copy"
        }, [_vm._v(_vm._s(scope.row.id))])])], 1), _vm._v(" "), _c('p', [_c('el-tooltip', {
          staticClass: "display-inline",
          attrs: {
            "placement": "top",
            "content": "Mã đơn HVC"
          }
        }, [_c('span', {
          staticClass: "shipment-code-display click-copy"
        }, [_vm._v(_vm._s(scope.row.code))])])], 1)]
      }
    }], null, false, 2568574317)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "COD"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "text-red click-copy"
        }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.amount_for_cross)))])]
      }
    }], null, false, 3320493449)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Người trả phí",
      "width": "105"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s(scope.row.payer_txt) + "\n            ")]
      }
    }], null, false, 2725581541)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Phí vận chuyển"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "text-red click-copy"
        }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.total_fee)))])]
      }
    }], null, false, 3846853147)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Phí khác"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v("Chuyển hoàn: "), _c('span', {
          staticClass: "text-red click-copy"
        }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.return_fee)))])]), _vm._v(" "), _c('p', [_vm._v("Vượt cân: "), _c('span', {
          staticClass: "text-red click-copy"
        }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.overweight_fee)))])])]
      }
    }], null, false, 26442921)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Cân nặng"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v("Cân nặng: "), _c('span', {
          staticClass: "text-orange click-copy"
        }, [_vm._v(_vm._s(_vm._f("gam")(scope.row.parcel.data.weight)))])]), _vm._v(" "), _c('p', [_vm._v("Cân thực tế: "), _c('span', {
          staticClass: "text-orange click-copy"
        }, [_vm._v(_vm._s(_vm._f("gam")(scope.row.parcel.data.real_weight)))])])]
      }
    }], null, false, 642939648)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Trạng thái",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          class: _vm.shipmentStatuses[scope.row.status]
        }, [_vm._v(_vm._s(scope.row.status_txt))])]
      }
    }], null, false, 3519113547)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Tổng tiền trả shop"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "text-red click-copy"
        }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.amount_return_shop)))])]
      }
    }], null, false, 4103530914)
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "remove-margin margin-top",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    staticClass: "padding-lg-right",
    attrs: {
      "span": 12,
      "offset": 12
    }
  }, [_c('h3', [_vm._v(" ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "text-bold"
  }, [_vm._v("Tổng tiền "), _c('sup', [_vm._v("(1)")]), _vm._v(":")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right text-red click-copy"
  }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.receipt.amount)))])]), _vm._v(" "), (_vm.receipt.money_return) ? _c('p', [_c('span', {
    staticClass: "text-bold"
  }, [_vm._v("Tiền nợ "), _c('sup', [_vm._v("(2)")]), _vm._v(":")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right text-red click-copy"
  }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.receipt.money_return)))])]) : _vm._e(), _vm._v(" "), (_vm.receipt.money_return) ? _c('p', [_c('span', {
    staticClass: "text-bold"
  }, [_vm._v("Tổng tiền thực trả "), _c('sup', [_vm._v("(1) - (2)")]), _vm._v(":")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right text-red click-copy"
  }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.receipt.real_amount)))])]) : _vm._e()])], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Cần truy thu công nợ",
      "visible": _vm.dialogReturner
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogReturner = $event
      }
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.listReturn,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Mã"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          attrs: {
            "href": "#",
            "target": "_blank"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.detailInvoiceBlankTab(scope.row.id)
            }
          }
        }, [_c('span', {
          staticClass: "shipment-code-display click-copy"
        }, [_vm._v(_vm._s(scope.row.id))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Số nợ"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "text-red click-copy"
        }, [_vm._v(_vm._s(_vm._f("number")(scope.row.real_amount)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('button', {
          staticClass: "ui mini violet button",
          attrs: {
            "type": "button",
            "disabled": _vm.pendingReturn
          },
          on: {
            "click": function($event) {
              return _vm.returnInvoice(scope.row)
            }
          }
        }, [_vm._v("Truy thu")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Đã truy thu công nợ",
      "visible": _vm.dialogReturned
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogReturned = $event
      }
    }
  }, [(_vm.receipt.returns) ? _c('el-table', {
    attrs: {
      "data": _vm.receipt.returns.data,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Mã",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          attrs: {
            "href": "#",
            "target": "_blank"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.detailInvoiceBlankTab(scope.row.invoice_id)
            }
          }
        }, [_c('span', {
          staticClass: "shipment-code-display click-copy"
        }, [_vm._v(_vm._s(scope.row.invoice_id))])])]
      }
    }], null, false, 2091597780)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Số tiền đã thu"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "text-red click-copy"
        }, [_vm._v(_vm._s(_vm._f("number")(scope.row.total_amount)))])]
      }
    }], null, false, 2899389486)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Người truy thu"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.returner) ? _c('span', {
          staticClass: "text-red"
        }, [_vm._v(_vm._s(scope.row.returner.data.name) + " |\n            " + _vm._s(scope.row.returner.data.email))]) : _vm._e()]
      }
    }], null, false, 524308329)
  })], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-92003384"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/receipt/DetailReceipt.vue
// module id = 655
// module chunks = 1